/**
 * @generated SignedSource<<15b9544d8a396edd1e10d107fc70dcab>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "networkOwnerId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "primaryName"
},
v2 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "OrganizationMutationGroup",
    "kind": "LinkedField",
    "name": "organization",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "fields": [
              {
                "kind": "Variable",
                "name": "networkOwnerId",
                "variableName": "networkOwnerId"
              },
              {
                "kind": "Variable",
                "name": "primaryName",
                "variableName": "primaryName"
              }
            ],
            "kind": "ObjectValue",
            "name": "input"
          }
        ],
        "concreteType": "OrganizationModifyPayload",
        "kind": "LinkedField",
        "name": "create",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Organization",
            "kind": "LinkedField",
            "name": "organization",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "NewOrganizationModalMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "NewOrganizationModalMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "579c06a1923452df3b4409154a9e9cc3",
    "id": null,
    "metadata": {},
    "name": "NewOrganizationModalMutation",
    "operationKind": "mutation",
    "text": "mutation NewOrganizationModalMutation(\n  $primaryName: String!\n  $networkOwnerId: ID!\n) {\n  organization {\n    create(input: {primaryName: $primaryName, networkOwnerId: $networkOwnerId}) {\n      organization {\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

node.hash = "1c7d6d0edef92d608ff9faf5fed66284";

export default node;
